































import { Component, Prop, Vue } from "vue-property-decorator";
import { ActionSheet, Dialog, Toast } from "vant";
import request from "@/api/index";
import { IFloating, IAdverInfoListItem, IShareInfo } from "@/api/types";
import { openUrl } from "@/common/utils";
import { needToken } from "@/common/decorator";
import native from "@/common/Native";
@Component({
  components: { [ActionSheet.name]: ActionSheet }
})
export default class Suspension extends Vue {
  @Prop()
  shareInfo!: IShareInfo;
  @Prop()
  informationId!: string;
  @Prop()
  infoClassifyid!: string;
  @Prop()
  appId!: string | number;
  floating: IFloating | null = null;
  isHide = false;
  show = false;
  mounted() {
    this.getFloating();
  }

  async getFloating() {
    const result = await request.floating(this.$store.state.infoClassifyId);
    if (result.code === 0) {
      this.floating = result.data;
    }
  }

  floatingClick() {
    /** 当只有一个跳转链接时 */
    if (this.floating!.adverInfoList.length === 1) {
      if (this.floating!.isJump === 0) {
        openUrl(this.floating!.adverInfoList[0].linkUrl);
      } else {
        this.replyUserStatus(this.floating!.adverInfoList[0].linkUrl);
      }
    } else {
      this.show = true;
    }
  }
  /**
   * 唤醒app
   */
  openApp() {
    const newsId = this.infoClassifyid;
    const shareInfo = this.shareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    const schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${newsId}&&&sourceId=${this.informationId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: this.informationId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }

  itemClick(item: IAdverInfoListItem) {
    this.show = false;
    if (this.floating!.isJump === 0) {
      openUrl(item.linkUrl);
    } else {
      this.replyUserStatus(item.linkUrl);
    }
  }

  // @needToken(true)
  async replyUserStatus(url: string) {
    if (!window.ZWY_CLOUD.isOpenInApp()) {
      this.openApp();
      return;
    }
    await native.goToken().then(info => {
      if (!info.phone) {
        Dialog.alert({
          title: "提示",
          message: "必须使用手机号登陆"
        }).then(() => {
          native.goToken(2).then(() => {
            if (location && location.reload) {
              location.reload();
            }
          });
        });
      } else {
        this.$store.commit("SET_STATE", info);
      }
    });
    console.log(this.$store.state);
    const result = await request.replyUserStatus(
      this.$store.state.infoClassifyId,
      this.$store.state.detail.sourceType
    );
    // 0:未评论,1:已评论（审核通过）
    console.log(result);
    if (result.code === 0) {
      if (result.data === 1) {
        openUrl(url);
      } else {
        Toast({
          message:
            "参与评论即可参加抽奖哦，请先评论吧。点击页面下方输入框，输入内容后即可发布评论。",
          duration: 2000
        });
      }
    } else {
      Toast.fail({
        message: result.message
      });
    }
  }

  hide() {
    this.isHide = true;
  }
}
